import axios from "axios";

const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? "https://api.habitat.inc/v1"
  : "/api/v1";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth header interceptor (uses accessCode from localStorage)
apiClient.interceptors.request.use((config) => {
  const accessCode = localStorage.getItem("accessCode");
  if (accessCode) {
    config.headers.Authorization = `Bearer ${accessCode}`;
  }
  return config;
});
